import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/(dashboard)/dashboard/$program/settings")({
  component: () => (
    <Outlet />
  ),
  errorComponent: ({ error }: { error: Error }) => (
    <div role="alert" className="p-4">
      <h2 className="text-xl font-bold">Error Loading Settings</h2>
      <pre className="mt-4">{error.message}</pre>
    </div>
  ),
});
